import { useQuery } from '@tanstack/react-query';
import { getConversation } from '../api/conversations';
import { useChatStore } from '../stores/chatStore';

export function useFetchConversationById(conversationId: string | null) {
  const isStreaming = useChatStore((s) => s.isStreaming);
  const resumeActive = useChatStore((s) => s.resumeActive);
  return useQuery({
    queryKey: ['conversation', conversationId],
    queryFn: () => getConversation(conversationId!),
    enabled: Boolean(conversationId),
    refetchInterval: isStreaming || resumeActive ? false : 10000,
    refetchIntervalInBackground: false,
  });
}
